export default {
  header: {
    navigation: {
      about: "About us",
      resources: "Resources",
      directory: "RGE Artisans Directory"
    },
    menu: "Menu"
  },
  home: {
    hero: {
      title1: "Become an Ambassador at",
      title2: "projetsolaire.",
      subtitle: "Join the Solar Revolution and Earn at the Same Time!",
      button: "Start",
      "learn-more": "Learn more",
      badge: "Let's accelerate the solar revolution, together.",
      "badge-link": "Learn more about us",
      "current-title": "Refer. Earn 500 €.<br/>Save the planet.",
      "current-description": "Get paid for sharing the benefits of solar energy with your neighbors, loved ones and colleagues. And help us change the world.",
      "image-alt": "Ambassador program hero image"
    },
    why: {
      whyup: "Why?",
      title: "Why become a solar energy ambassador?",
      reason1: {
        title: "Environmental Impact:",
        description:
          "Contribute to the fight against climate change by promoting a clean and renewable energy source.",
      },
      reason2: {
        title: "Additional Income:",
        description:
          "Earn money by recommending our services and helping homeowners switch to solar energy.",
      },
      reason3: {
        title: "Training and Support:",
        description:
          "Benefit from comprehensive training and ongoing support to succeed as an ambassador.",
      },
      reason4: {
        title: "Flexibility:",
        description:
          "Work at your own pace, wherever you want, according to your schedule and lifestyle.",
      },
      caption:
        '"I have already sponsored two friends and was able to accompany them on their journey to self-consumption. Their installations went smoothly, they are delighted. Everyone wins!"',
    },
    how: {
      title: "How to get started?",
      description: "Here are the steps for projetsolaire ambassadors.",
      step1: {
        title: "Application",
        description: "Submit your application in just a few clicks.",
      },
      step2: {
        title: "Sponsorship",
        description:
          "Start sponsoring your contacts who want to switch to photovoltaics.",
      },
      step3: {
        title: "Reward",
        description: "Receive 500 euros for each quote you get signed.",
      },
    },
    tools: {
      title: "Our tools",
      description: "We give you access to tools to make your task easier.",
      tool1: {
        title: "Training:",
        description:
          "Benefit from comprehensive training to launch yourself into the solar adventure with complete peace of mind!",
      },
      tool2: {
        title: "Support:",
        description:
          "You will receive marketing materials to help you achieve your goals.",
      },
    },
    faq: {
      title: "Frequently Asked Questions (FAQ):",
      q1: {
        question: "How does the ambassador program work?",
        respond:
          "Our ambassador program rewards you every time you recommend a client who signs a quote with us. The more you recommend, the more you earn.",
      },
      q2: {
        question: "Are there any costs associated with becoming an ambassador?",
        respond: "No, registration as an ambassador is completely free.",
      },
      q3: {
        question: "Do I need prior knowledge of solar energy?",
        respond:
          "No, we provide comprehensive training to prepare you to promote our services.",
      },
    },
    cta: {
      title: "Become an Ambassador at projetsolaire",
      description:
        "Join our team of ambassadors passionate about electrical self-consumption and transform your passion into profit. As an ambassador, you will have the opportunity to promote electrical independence and help people save on their energy bills while earning money. Be a leader in the movement towards a smarter and more economical energy future.",
      button: "Join the adventure",
    },
    banner: {
      paragraph: "Sponsor today to receive multiple artisan quotes",
      description:
        "It's as simple as that to contribute to eliminating tons of CO2 from the atmosphere. And the more people you sponsor, the more chances you have to receive €500 per sponsorship, paid directly to your bank account.",
      button: "I sponsor!",
    },
  },
  "sign-in": {
    title: "Welcome, help us grow photovoltaics in France!",
  },
  faq: {
    title: "Our answers to your questions about paid word-of-mouth",
  },
}